// Taxonomy for INTERNAL concentration limits — the vocabulary the "Add new internal
// limit" form exposes and the server validates against. Mirrors the DB registry
// (athena_bfsi_prc.prc_limit_config); the v_prc_concentrations view, and therefore the
// Capacity table, reflect a new limit on the next read — no per-limit view/DDL.

export type PrcDimension = "state" | "asset_industry" | "sic_code" | "obligor";
export type PrcMatchOperator = "IN" | "SIC_RANGE" | "TOP_N";

/** Sensible default operator for a dimension. */
export function defaultOperator(dim: PrcDimension): PrcMatchOperator {
  return dim === "obligor" ? "TOP_N" : "IN";
}

/** Placeholder/hint text describing the expected match_values for a dimension+operator. */
export function valuesHint(dim: PrcDimension, op: PrcMatchOperator): string {
  if (dim === "obligor") return "N — e.g. 1 for the single top obligor, 5 for top 5";
  if (dim === "state") return "State codes, comma-separated — e.g. CA or CA, OR, WA";
  if (dim === "asset_industry")
    return "Asset segments, comma-separated — e.g. MEDICAL or SOFTWARE, COMPUTER EQUIPMENT";
  if (dim === "sic_code" && op === "SIC_RANGE") return "Two SIC codes (from, to) — e.g. 2000, 3999";
  return "SIC codes, comma-separated — e.g. 5812, 7231";
}
